import React from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import { AllocationMode } from './budgetallocation.models';

type Props = { open:boolean; activityCount:number; lineItemCount:number; controlAvailable?:number; onClose:()=>void; onSubmit:(mode:AllocationMode,totalAmount:number)=>void; };
type State = { mode: AllocationMode; totalAmount: string; };

class BudgetAllocationBulkDialog extends React.Component<Props,State> {
  state: State = { mode:'RATIO_ONLY', totalAmount:'0' };
  componentDidUpdate(prev:Props) {
    if (!prev.open && this.props.open) {
      const mode:AllocationMode = this.props.lineItemCount===1 && this.props.activityCount>1 ? 'MAP_FULL' : 'RATIO_ONLY';
      this.setState({mode,totalAmount:'0'});
    }
  }
  submit=()=>this.props.onSubmit(this.state.mode,Number(this.state.totalAmount||0));
  render(){
    const {activityCount,lineItemCount}=this.props;
    const matrixRequired=activityCount>1 && lineItemCount>1;
    const manyToOne=activityCount>1 && lineItemCount===1;
    const oneToMany=activityCount===1 && lineItemCount>1;
    return <Dialog open={this.props.open} onClose={this.props.onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Allocate Activity Plans to Budget Accounts</DialogTitle>
      <DialogContent><Stack spacing={2} sx={{mt:1}}>
        <Typography variant="body2">Selected Activity Plans: <b>{activityCount}</b><br/>Selected accounts: <b>{lineItemCount}</b></Typography>
        {matrixRequired && <Alert severity="warning">Many-to-many allocation is not performed by the quick dialog. Select one Activity Plan or one account. A matrix workflow can be introduced later.</Alert>}
        {manyToOne && <Alert severity="info">Each selected Activity Plan will be mapped independently and fully to the selected account. No amount is split between activities.</Alert>}
        {oneToMany && <Alert severity="info">The selected Activity Plan may be distributed across the selected accounts.</Alert>}
        <Alert severity="info">
          Activity Budget Control available: <b>{Number(this.props.controlAvailable||0).toLocaleString('fr-FR')}</b>.
          Mapping must classify existing Activity budget; it must not create additional budget.
        </Alert>
        {!matrixRequired && <FormControl fullWidth><InputLabel>Allocation Mode</InputLabel><Select label="Allocation Mode" value={this.state.mode} onChange={(e)=>this.setState({mode:e.target.value as AllocationMode})}>
          {manyToOne && <MenuItem value="MAP_FULL">Map each Activity Plan fully to this account</MenuItem>}
          {!manyToOne && <MenuItem value="RATIO_ONLY">Equal ratios only — no amount</MenuItem>}
          {!manyToOne && <MenuItem value="EQUAL_BY_ACCOUNT">Split a total amount equally by account</MenuItem>}
        </Select></FormControl>}
        {this.state.mode==='EQUAL_BY_ACCOUNT' && !matrixRequired && <TextField label="Total Amount" type="number" value={this.state.totalAmount} onChange={(e)=>this.setState({totalAmount:e.target.value})} fullWidth/>}
      </Stack></DialogContent>
      <DialogActions><Button onClick={this.props.onClose}>Cancel</Button><Button onClick={this.submit} variant="contained" disabled={matrixRequired||activityCount===0||lineItemCount===0||(this.state.mode==='EQUAL_BY_ACCOUNT'&&Number(this.state.totalAmount||0)>Number(this.props.controlAvailable||0))}>Allocate</Button></DialogActions>
    </Dialog>;
  }
}
export default BudgetAllocationBulkDialog;
